<template>
    <div class="dialog bg-light light w-100-sm w-100-md w-75-lg  w-50-xl h-75" id="policy_dialog">
        <div class="dialog-title pl-10 pl-10">
            <h5 class="text-bold mt-3">{{ policy.id == null ? $t('Create new policy') : $t('Edit') + ': ' + policy.name }}</h5>
            <h6 v-if="policy.id != null" class="mt-3">{{ $t('Type') + ': ' + $t(policy.name_type) }}</h6>
            <label v-if="!['', -1].includes(policy.id_type)" class="text-small">{{$t('Description') + ': ' + $t($session.getPolicyTypes().find((type) => type.id == policy.id_type).description)}}</label>
            <span class="button square closer" @click="$root.$emit('CLOSEPOLICYVIEWDIALOG')"></span>
        </div>
        <div class="dialog-content overflow bg-light">
            <div id="profile">
                <div class="form-group">
                    <label>{{ $t("Name") }}*</label>
                    <input data-role="input" class="input" required v-model.trim="policy.name" type="text" data-prepend="<span class='mif-folder'></span>" />
                    
                </div>
                <div class="d-flex flex-align-center row ">
                    <div class="form-group cell-5" v-if="policy.id == null">
                        <label>{{ $t("Type") }}*</label>
                        <select class="input w-auto" data-filter="false" id="typeselect"
                            v-model="policy.id_type" @change="formatTree">
                            <option v-for="policytypes in $session.getPolicyTypes()" :value="policytypes.id" :key="policytypes.id"> {{ $t(policytypes.name) }} </option>
                        </select>
                        
                    </div>
                  
                </div>
                
                <div class="form-group p-3" v-if="policy.id_type != 1">
                    
                    
                    <input  data-role="switch" type="checkbox" :data-caption="$t('Select by Groups')" v-model="selectType" />
                    
                    
                    <div v-show="selectType">
                       <label>{{ $t("Groups") }}</label>
                       <select v-model="specifiedGroups" multiple data-role="select" class="input">
                            <option data-template="<span class='mif-folder icon pt-1'></span> $1" v-for="group in $session.getGroups()" :value="group.id_group" :key="group.id_group"> 
                                {{ group.name_group }} 
                            </option>
                        </select>
                    </div>
                    <div v-show="!selectType" >
                        <label>{{ $t("Devices") }}</label>
                        <select  class="input" data-role="select"
                            data-cls-selected-item="bg-light border pr-2 rounded" data-cls-selected-item-remover="bg-transparent border-0 d-flex flex-align-center" data-filter="true" multiple id="computerselect" name="ids_computers" @change="onChange('computers', 'computerselect')">
                            <option :selected="policy.computers.find(elem => elem == pc.id)" v-for="pc in computers" :value="pc.id" :key="pc.id" data-template="<span class='mif-laptop icon pt-1'></span> $1">
                                {{ pc.pc_name }} <label v-if="pc.organization_name != ''">({{ pc.organization_name }})</label>
                            </option>
                        </select>
                    </div>
                </div>

                <!--HARDWARE MONITORING-->
                <div v-if="policy.id_type == 3">
                    <div class="form-group">
                        <label>{{ $t("Send notification after") }}*</label>
                        <input type="number" v-number v-range="{ min: 1, max: 999 }" :min="0" v-model.number="policy.policy.threshold_duration" class="input w-auto">
                        <small class="muted">*{{ $t("in minutes") }}</small>
                    </div>
                    <div class="form-group ">
                        <!--div>
                            <label>{{ $t("Threshold CPU") }}%</label>
                            <input type="number" id="threshold_cpu" v-model.number="policy.policy.threshold_cpu"
                                class="ultra-thin cycle-marker" data-hint-always="true" data-cls-complete="bg-secondary"
                                data-cls-hint="bg-secondary fg-black custom-marker "
                                data-cls-marker="bg-secondary fg-black border-50 custom-marker" data-role="slider" data-hint="true"
                                data-hint-position="top" :data-value="policy.policy.threshold_cpu" data-max="100"
                                data-min="0">
                        </div-->
                        <div :class="isCpuActive ? 'th-active' : 'th-inactive'">
                        <label :class="isCpuActive ? 'label-active' : 'label-inactive'"
                            for="threshold_cpu"
                            style="display:inline-flex; align-items:center;">
                            {{ $t('Threshold CPU') }}%
                            <svg 
                                width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"
                                style="margin-left:.4rem; fill: currentColor;"><title>{{ $t('Set the CPU usage percentage threshold above which to generate an alert. 0% disables this check. Allowed values: 0–100%. Example: 85% → an alert is sent when CPU usage exceeds 85%. Useful for spotting abnormal loads or stuck processes.') }}</title>
                                <path d="M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2Zm0 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-8.75A2.75 2.75 0 0 0 9.25 9.5a.75.75 0 0 0 1.493.102l.007-.102a1.25 1.25 0 1 1 2.5 0c0 .539-.135.805-.645 1.332l-.135.138c-.878.878-1.22 1.447-1.22 2.53a.75.75 0 0 0 1.5 0c0-.539.135-.805.645-1.332l.135-.138c.878-.878 1.22-1.447 1.22-2.53A2.75 2.75 0 0 0 12 6.75Z"></path>
                            </svg>
                        </label>
                        <input
                            type="hidden"
                            id="threshold_cpu"
                            class="ultra-thin cycle-marker"
                            data-hint-always="true"
                            data-cls-complete="bg-secondary"
                            data-cls-hint="bg-secondary fg-white custom-marker"
                            data-cls-marker="bg-secondary fg-white border-50 custom-marker"
                            data-role="slider"
                            data-hint="true"
                            data-hint-position="bottom"
                            :data-value="policy.policy.threshold_cpu"
                            data-max="100"
                            data-min="0" @change="onSliderChange"
                        />
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <div :class="isRamActive ? 'th-active' : 'th-inactive'">
                            <label :class="isRamActive ? 'label-active' : 'label-inactive'" for="threshold_ram"
                            style="display:inline-flex; align-items:center;">{{ $t("Threshold RAM") }}%
                            <svg
                                width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"
                                style="margin-left:.4rem; fill: currentColor;"><title>{{ $t('Set the RAM usage percentage threshold above which to generate an alert. 0% disables this check. Allowed values: 0–100%. Example: 90% → an alert is sent when RAM usage exceeds 90%. Useful for detecting memory saturation that can cause slowdowns or swapping.') }}</title>
                                <path d="M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2Zm0 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-8.75A2.75 2.75 0 0 0 9.25 9.5a.75.75 0 0 0 1.493.102l.007-.102a1.25 1.25 0 1 1 2.5 0c0 .539-.135.805-.645 1.332l-.135.138c-.878.878-1.22 1.447-1.22 2.53a.75.75 0 0 0 1.5 0c0-.539.135-.805.645-1.332l.135-.138c.878-.878 1.22-1.447 1.22-2.53A2.75 2.75 0 0 0 12 6.75Z"></path>
                            </svg></label>

                            <input id="threshold_ram"
                                type="hidden"
                                class="ultra-thin cycle-marker" data-hint-always="true" data-cls-complete="bg-secondary"
                                data-cls-hint="bg-secondary fg-white custom-marker"
                                data-cls-marker="bg-secondary fg-white border-50 custom-marker" data-role="slider" data-hint="true"
                                data-hint-position="bottom" :data-value="policy.policy.threshold_ram" data-max="100"
                                data-min="0" @change="onSliderChange">
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <div :class="isDiskActive ? 'th-active' : 'th-inactive'">
                            <label :class="isDiskActive ? 'label-active' : 'label-inactive'" for="threshold_disk" style="display:inline-flex; align-items:center;">{{ $t("Threshold DISK") }}%
                                 <svg
                                width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"
                                style="margin-left:.4rem; fill: currentColor;"><title>{{ $t('Set the system disk utilization percentage threshold (where the operating system is installed) above which to generate an alert. 0% disables this check. Allowed values: 0-100%. Example: 80% → an alert is sent when system disk I/O activity exceeds 80%. Useful for spotting bottlenecks due to high I/O.') }}</title>
                                <path d="M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2Zm0 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-8.75A2.75 2.75 0 0 0 9.25 9.5a.75.75 0 0 0 1.493.102l.007-.102a1.25 1.25 0 1 1 2.5 0c0 .539-.135.805-.645 1.332l-.135.138c-.878.878-1.22 1.447-1.22 2.53a.75.75 0 0 0 1.5 0c0-.539.135-.805.645-1.332l.135-.138c.878-.878 1.22-1.447 1.22-2.53A2.75 2.75 0 0 0 12 6.75Z"></path>
                            </svg>
                            </label>
                            <input type="hidden" id="threshold_disk"
                                class="ultra-thin cycle-marker" data-hint-always="true" data-cls-complete="bg-secondary"
                                data-cls-hint="bg-secondary fg-white custom-marker"
                                data-cls-marker="bg-secondary fg-white border-50 custom-marker" data-role="slider" data-hint="true"
                                data-hint-position="bottom" :data-value="policy.policy.threshold_disk" data-max="100"
                                data-min="0" @change="onSliderChange">
                        </div>
                    </div>
                </div>

                <!--PATCH SISTEMA OPERATIVO-->
                <div v-if="policy.id_type == 2">
                    <div class="form-group">
                        <label>{{ $t("Update time") }}</label>
                        <input data-role="input" class="input w-auto"
                            :value="policy.policy.update_time != null && policy.policy.update_time != '' ? cronstrue.toString(policy.policy.update_time, { locale: $i18n.locale, dayOfWeekStartIndexZero: false }) : ''"
                            type="text" @click="$root.$emit('OPENSCHEDULATIONVIEWDIALOG', '')"
                            data-prepend="<span class='mif-calendar'></span>" />
                    </div>



                    <div class="form-group mt-5">
                        <label class="text-bold">{{ $t('OS Patch Management') }}*</label>
                        <ul data-role="treeview" class="treeview p-0" id="patchview">

                            <!-- Security Updates -->
                            <li>
                                <input
                                class="ml-3 text-bold"
                                data-style="1"
                                type="checkbox"
                                data-role="checkbox"
                                :data-caption="$t('Security Updates')"
                                :title="$t('Security Updates')"
                                value='["0fa1201d-4330-4fa8-8ae9-b877473b6441","e0789628-ce08-4437-be74-2495b842f43b","28bc880e-0592-4cbf-8f95-c79b17911d5f"]'
                                :checked="isGroupChecked(['0fa1201d-4330-4fa8-8ae9-b877473b6441', 'e0789628-ce08-4437-be74-2495b842f43b', '28bc880e-0592-4cbf-8f95-c79b17911d5f'])"
                                @change="onCategoryChange"
                                >
                                <ul>
                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="0fa1201d-4330-4fa8-8ae9-b877473b6441"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('0fa1201d-4330-4fa8-8ae9-b877473b6441')"
                                    :data-caption="$t(patchCategories['0fa1201d-4330-4fa8-8ae9-b877473b6441'])"
                                    :title="$t(patchCategories['0fa1201d-4330-4fa8-8ae9-b877473b6441'])"
                                    @change="onCategoryChange"
                                    >
                                </li>

                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="e0789628-ce08-4437-be74-2495b842f43b"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('e0789628-ce08-4437-be74-2495b842f43b')"
                                    :data-caption="$t(patchCategories['e0789628-ce08-4437-be74-2495b842f43b'])"
                                    :title="$t(patchCategories['e0789628-ce08-4437-be74-2495b842f43b'])"
                                    @change="onCategoryChange"
                                    >
                                </li>

                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="28bc880e-0592-4cbf-8f95-c79b17911d5f"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('28bc880e-0592-4cbf-8f95-c79b17911d5f')"
                                    :data-caption="$t(patchCategories['28bc880e-0592-4cbf-8f95-c79b17911d5f'])"
                                    :title="$t(patchCategories['28bc880e-0592-4cbf-8f95-c79b17911d5f'])"
                                    @change="onCategoryChange"
                                    >
                                </li>
                                </ul>
                            </li>

                            <!-- Service packs -->
                            <li>
                                <input
                                class="ml-3 text-bold"
                                data-style="1"
                                type="checkbox"
                                data-role="checkbox"
                                :data-caption="$t('Service packs')"
                                :title="$t('Service packs')"
                                value='["68c5b0a3-d1a6-4553-ae49-01d3a7827828","b54e7d24-7add-428f-8b75-90a396fa584f","cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83"]'
                                :checked="isGroupChecked(['68c5b0a3-d1a6-4553-ae49-01d3a7827828', 'b54e7d24-7add-428f-8b75-90a396fa584f', 'cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83'])"
                                @change="onCategoryChange"
                                >
                                <ul>
                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="68c5b0a3-d1a6-4553-ae49-01d3a7827828"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('68c5b0a3-d1a6-4553-ae49-01d3a7827828')"
                                    :data-caption="$t(patchCategories['68c5b0a3-d1a6-4553-ae49-01d3a7827828'])"
                                    :title="$t(patchCategories['68c5b0a3-d1a6-4553-ae49-01d3a7827828'])"
                                    @change="onCategoryChange"
                                    >
                                </li>

                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="b54e7d24-7add-428f-8b75-90a396fa584f"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('b54e7d24-7add-428f-8b75-90a396fa584f')"
                                    :data-caption="$t(patchCategories['b54e7d24-7add-428f-8b75-90a396fa584f'])"
                                    :title="$t(patchCategories['b54e7d24-7add-428f-8b75-90a396fa584f'])"
                                    @change="onCategoryChange"
                                    >
                                </li>

                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83')"
                                    :data-caption="$t(patchCategories['cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83'])"
                                    :title="$t(patchCategories['cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83'])"
                                    @change="onCategoryChange"
                                    >
                                </li>
                                </ul>
                            </li>

                            <!-- Drivers and Tools -->
                            <li>
                                <input
                                class="ml-3 text-bold"
                                data-style="1"
                                type="checkbox"
                                data-role="checkbox"
                                :data-caption="$t('Drivers and Tools')"
                                :title="$t('Drivers and Tools')"
                                value='["ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0","b4832bd8-e735-4761-8daf-37f882276dab"]'
                                :checked="isGroupChecked(['ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0', 'b4832bd8-e735-4761-8daf-37f882276dab'])"
                                @change="onCategoryChange"
                                >
                                <ul>
                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0')"
                                    :data-caption="$t(patchCategories['ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0'])"
                                    :title="$t(patchCategories['ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0'])"
                                    @change="onCategoryChange"
                                    >
                                </li>

                                <li>
                                    <input
                                    class="ml-3"
                                    data-style="1"
                                    type="checkbox"
                                    data-role="checkbox"
                                    value="b4832bd8-e735-4761-8daf-37f882276dab"
                                    :checked="policy.policy.included_categories && policy.policy.included_categories.includes('b4832bd8-e735-4761-8daf-37f882276dab')"
                                    :data-caption="$t(patchCategories['b4832bd8-e735-4761-8daf-37f882276dab'])"
                                    :title="$t(patchCategories['b4832bd8-e735-4761-8daf-37f882276dab'])"
                                    @change="onCategoryChange"
                                    >
                                </li>
                                </ul>
                            </li>

                            <!-- Single category -->
                            <li>
                                <input
                                class="ml-3 text-bold"
                                data-style="1"
                                type="checkbox"
                                data-role="checkbox"
                                value="e6cf1350-c01b-414d-a61f-263d14d133b4"
                                :checked="policy.policy.included_categories && policy.policy.included_categories.includes('e6cf1350-c01b-414d-a61f-263d14d133b4')"
                                :data-caption="$t(patchCategories['e6cf1350-c01b-414d-a61f-263d14d133b4'])"
                                :title="$t(patchCategories['e6cf1350-c01b-414d-a61f-263d14d133b4'])"
                                @change="onCategoryChange"
                                >
                            </li>

                            </ul>

                        <!--<ul data-role="treeview" class="treeview p-0" id="patchview">

                            <li>
                                <input class="ml-3 text-bold" data-style="1" type="checkbox" data-role="checkbox"
                                    :data-caption="$t('Security Updates')" :title="$t('Security Updates')"
                                    value='["0fa1201d-4330-4fa8-8ae9-b877473b6441","e0789628-ce08-4437-be74-2495b842f43b","28bc880e-0592-4cbf-8f95-c79b17911d5f"]'>
                                <ul>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="0fa1201d-4330-4fa8-8ae9-b877473b6441"
                                            :checked="policy.policy.included_categories?.includes('0fa1201d-4330-4fa8-8ae9-b877473b6441')"
                                            :data-caption="$t(patchCategories['0fa1201d-4330-4fa8-8ae9-b877473b6441'])"
                                            :title="$t(patchCategories['0fa1201d-4330-4fa8-8ae9-b877473b6441'])">
                                    </li>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="e0789628-ce08-4437-be74-2495b842f43b"
                                            :checked="policy.policy.included_categories?.includes('e0789628-ce08-4437-be74-2495b842f43b')"
                                            :data-caption="$t(patchCategories['e0789628-ce08-4437-be74-2495b842f43b'])"
                                            :title="$t(patchCategories['e0789628-ce08-4437-be74-2495b842f43b'])">
                                    </li>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="28bc880e-0592-4cbf-8f95-c79b17911d5f"
                                            :checked="policy.policy.included_categories?.includes('28bc880e-0592-4cbf-8f95-c79b17911d5f')"
                                            :data-caption="$t(patchCategories['28bc880e-0592-4cbf-8f95-c79b17911d5f'])"
                                            :title="$t(patchCategories['28bc880e-0592-4cbf-8f95-c79b17911d5f'])">
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <input class="ml-3 text-bold" data-style="1" type="checkbox" data-role="checkbox"
                                    :data-caption="$t('Service packs')" :title="$t('Service packs')"
                                    value='["68c5b0a3-d1a6-4553-ae49-01d3a7827828","b54e7d24-7add-428f-8b75-90a396fa584f","cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83"]'>
                                <ul>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="68c5b0a3-d1a6-4553-ae49-01d3a7827828"
                                            :checked="policy.policy.included_categories?.includes('68c5b0a3-d1a6-4553-ae49-01d3a7827828')"
                                            :data-caption="$t(patchCategories['68c5b0a3-d1a6-4553-ae49-01d3a7827828'])"
                                            :title="$t(patchCategories['68c5b0a3-d1a6-4553-ae49-01d3a7827828'])">
                                    </li>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="b54e7d24-7add-428f-8b75-90a396fa584f"
                                            :checked="policy.policy.included_categories?.includes('b54e7d24-7add-428f-8b75-90a396fa584f')"
                                            :data-caption="$t(patchCategories['b54e7d24-7add-428f-8b75-90a396fa584f'])"
                                            :title="$t(patchCategories['b54e7d24-7add-428f-8b75-90a396fa584f'])">
                                    </li>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83"
                                            :checked="policy.policy.included_categories?.includes('cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83')"
                                            :data-caption="$t(patchCategories['cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83'])"
                                            :title="$t(patchCategories['cd5ffd1e-e932-4e3a-bf74-18bf0b1bbd83'])">
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <input class="ml-3 text-bold" data-style="1" type="checkbox" data-role="checkbox"
                                    :data-caption="$t('Drivers and Tools')" :title="$t('Drivers and Tools')"
                                    value='["ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0","b4832bd8-e735-4761-8daf-37f882276dab"]'>
                                <ul>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0"
                                            :checked="policy.policy.included_categories?.includes('ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0')"
                                            :data-caption="$t(patchCategories['ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0'])"
                                            :title="$t(patchCategories['ebfc1fc5-71a4-4f7b-9aca-3b9a503104a0'])">
                                    </li>
                                    <li>
                                        <input class="ml-3" data-style="1" type="checkbox" data-role="checkbox"
                                            value="b4832bd8-e735-4761-8daf-37f882276dab"
                                            :checked="policy.policy.included_categories?.includes('b4832bd8-e735-4761-8daf-37f882276dab')"
                                            :data-caption="$t(patchCategories['b4832bd8-e735-4761-8daf-37f882276dab'])"
                                            :title="$t(patchCategories['b4832bd8-e735-4761-8daf-37f882276dab'])">
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <input class="ml-3 text-bold" data-style="1" type="checkbox" data-role="checkbox"
                                    value="e6cf1350-c01b-414d-a61f-263d14d133b4"
                                    :checked="policy.policy.included_categories?.includes('e6cf1350-c01b-414d-a61f-263d14d133b4')"
                                    :data-caption="$t(patchCategories['e6cf1350-c01b-414d-a61f-263d14d133b4'])"
                                    :title="$t(patchCategories['e6cf1350-c01b-414d-a61f-263d14d133b4'])">
                            </li>
                        </ul>-->
                    </div>

                    <div class="form-group  mt-3">
                        <input data-role="checkbox" type="checkbox" :data-caption="$t('Reboot auto')"
                            v-model="policy.policy.reboot_auto" /><br>
                    </div>


                    <div class="row ml-3 d-flex">

                        <div class="form-group cell-3">
                            <label class="no-wrap">{{ $t("Reboot time from") }}</label>
                            <input :disabled="!policy.policy.reboot_auto" class="input w-auto"
                                v-model="policy.policy.reboot_time_inf" type="time" />
                        </div>
                        <div class="form-group cell-3">
                            <label class="no-wrap">{{ $t("Reboot time to") }}</label>
                            <input :disabled="!policy.policy.reboot_auto" class="input w-auto"
                                v-model="policy.policy.reboot_time_sup" type="time" />
                        </div>
                    </div>
                </div>
                <!--SCHEDULING-->
                <div v-if="policy.id_type == 1">
                    <div class="form-group">
                        <label>{{ $t("Scheduling") }}</label>
                        <div class="row">
                            <input class="input w-50" v-if="policy.policy.scheduling[0] != ''" 
                                :value="cronstrue.toString(policy.policy.scheduling[0], { locale: $i18n.locale, dayOfWeekStartIndexZero: false })"
                                type="text" />

                            <button class="button secondary" :class="policy.policy.scheduling[0] != '' ? 'ml-2' : ''" @click="$root.$emit('OPENSCHEDULATIONVIEWDIALOG', policy.policy.scheduling[0])">
                                {{ policy.policy.scheduling[0] != '' ? $t("Edit Scheduling") : $t("Create Scheduling") }}
                            </button>
                        </div>
                    </div>

                    <div class="form-group  mt-3">
                        <input data-role="checkbox" type="checkbox" :data-caption="$t('Enable Misfire Alert')"  v-model="policy.policy.misfire_alert" /><br>
                    </div>
                    <div class="form-group  mt-3">
                         <input  data-role="switch" type="checkbox" :data-caption="$t('Select by Groups')" v-model="selectType" />
                    </div>

                    <div v-show="selectType" >
                        <div class="form-group" >
                            <label>{{ $t("Groups") }}</label>
                            <select v-model="specifiedGroups" multiple data-role="select" class="input">
                                <option data-template="<span class='mif-folder icon pt-1'></span> $1" v-for="group in $session.getGroups()" :value="group.id_group" :key="group.id_group"> 
                                    {{ group.name_group }} 
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group" v-if="backupTree" v-show="!selectType">
                        <label>{{ $t('Select Backups') }}</label>
                        <ul data-role="treeview" id="treeviewbackup">
                            <li data-icon="" data-caption="" v-for="computer in backupTree.computers">
                                <input :key="computer.id" name="computer" :value="computer.id" type="checkbox"
                                    data-role="checkbox" :data-caption="computer.name" :title="computer.name">
                                <ul v-if="computer.jobs.length != 0">
                                    <li data-icon="" data-caption="" v-for="backup in computer.jobs">
                                        <input :key="backup.id" name="backup" :value="backup.id" type="checkbox"
                                            data-role="checkbox" :data-caption="backup.name" :title="backup.name"
                                            v-model="policy.jobs">
                                    </li>

                                </ul>
                            </li>


                        </ul>
                    </div>

                </div>


            </div>
        </div>
        <div class="dialog-actions">
            <ClientMessageView :commands="['policymethods']"/>

            <button v-if="policy.id != null" class="button secondary ml-2" @click="$root.$emit('deletePolicy', policy)">{{ $t("Delete") }}</button>
            <button :disabled="isSaveButtonDisabled" v-disable-tooltip:saveButtonDisabled_message class="button secondary" @click="save">{{ policy.id == "" ? $t('Create') : $t("Save") }}</button>
            <button class="button ml-2" @click="$root.$emit('CLOSEPOLICYVIEWDIALOG')">{{ $t("Close") }}</button>
        </div>
    </div>
</template>
<script>

import patchCategories from "../../../components/utils/patchCategories";
import $ from 'jquery';
import { draggableMixin } from '../../../mixins/draggable-mixin'
import ClientMessageView from "./ClientMessageView.vue";
import { isValid, waitSeconds } from "../../../utils/utilitiesmodule";

export default {

    name: "PolicyDialog",

    mixins: [draggableMixin],
    components: {
        ClientMessageView
    },
    data() {
        return {
            cronstrue: require('cronstrue/i18n'),
            patchCategories: patchCategories,
            backupTree: null,
            jobsSelected: [],
            oldComputers: [],
            selectType: false,
            specifiedGroups : []
        }
    },
    props: {

        policy: {
            type: Object,
            required: true
        },

        computers: {
            type: Array,
            required: true
        },



    },
    computed: {
        isPolicyDisabled() {
            //const p=this.policy||{};

            const p=this.policy?.policy||{}

            // forza tracking anche se poi non usi i valori
            const cpu=Number(p.threshold_cpu||0)
            const disk=Number(p.threshold_disk||0)
            const ram=Number(p.threshold_ram||0)

            const idTypeEmpty=this.policy.id_type==='';
            const nameEmpty=this.policy.name==='';
            if (nameEmpty) {
                return {
                    disabled: true,
                    message: this.$t("Insert a name")
                }
            }

            if (idTypeEmpty) {
                return {
                    disabled: true,
                    message: this.$t("Select a policy type")
                }
            }

            switch (Number(this.policy.id_type)) {
                case 1://scheduling
                    if (p.scheduling.length==0||p.scheduling[0]=="") {
                        return {
                            disabled: true,
                            message: this.$t('Configure scheduling')
                        };
                    }
                    break;
                case 2: //patch os
                    if (p.included_categories.length==0) {
                        return {
                            disabled: true,
                            message: this.$t('Select at least one patch category')
                        };
                    }
                    break;
                case 3: //hardware monitoring
                    const sum=cpu+disk+ram;

                    if (sum<1) {
                        return {
                            disabled: true,
                            message: this.$t('To save the policy, at least one threshold has to be above zero.')
                        };
                    }
                    break;
                case 7: //status monitoring
                    if (this.policy.computers.length==0&&this.policy.groups.length==0) {
                        return {
                            disabled: true,
                            message: this.$t('Select at least one group or device')
                        };
                    }
                    break;
            }

            return {
                disabled: false,
                message: ''
            };

        },

        isSaveButtonDisabled() {
            return this.isPolicyDisabled.disabled;
        },

        saveButtonDisabled_message() {
            return this.isPolicyDisabled.message;
        },

        isCpuActive() {
            return Number(this.policy?.policy?.threshold_cpu||0)>0;
        },
        isDiskActive() {
            return Number(this.policy?.policy?.threshold_disk||0)>0;
        },
        isRamActive() {
            return Number(this.policy?.policy?.threshold_ram||0)>0;
        }

    },

    mounted() {
        let self=this;
        self.cronstrue=require('cronstrue/i18n');
        self.$api.getBackupTree().then(tree => {
            self.backupTree=tree;
            self.runMethodWithDelay(self.formatTree, 350);
        });
        self.oldComputers=self.policy.computers;
        self.selectType=self.policy.groups.length!=0;

        if(self.selectType){
            self.specifiedGroups.update(self.policy.groups);
        }
        self.$root.$on("REFRESHSCHEDULATION", (schedulationString) => {
            if (!isValid(schedulationString)) {
                return;
            }
            self.policy.policy.scheduling.clear();
            self.policy.policy.scheduling.push(schedulationString);
        });
    },
    beforeDestroy() {
        this.$root.$off("REFRESHSCHEDULATION");
    },
    methods: {
        runMethodWithDelay(callback, delay) {
            setTimeout(callback, delay);
        },

        onChange(what, id) {
            var arr = this.policy[what];
            arr.push(window.Metro.getPlugin($("#"+id), 'select').val());
            arr = arr.distinctBy(null);
            this.policy[what].update(arr);



        },

        async formatTree() {
            let self=this;


            /*
            
            "policy": {
                //scheduling
                "misfire_alert": false,
                "scheduling": [""],
                
                //HARDWARE MONITORING
                "threshold_duration": 60,
                "threshold_cpu":0,
                "threshold_disk":0,
                "threshold_ram":0,

                //PATCH SISTEMA OPERATIVO
                "included_categories": [],
                "update_time": null,
                "reboot_auto" : false,
                "reboot_time_inf" : null,
                "reboot_time_sup" : null
            },
            */
            var type=this.policy.id_type;
            this.policy.id_type=-1;
            //questa impercettibile attesa mi consente di cambiare senza problemi gli elementi visualizzati, dato che MetroUI non li distrugge
            await waitSeconds(0.05);
            this.policy.id_type=type;
            switch (this.policy.id_type) {

                case 1: //scheduling

                    var treeview=Metro.getPlugin('#treeviewbackup', 'treeview');
                    if (treeview!=undefined) {

                        treeview.options.onCheckClick=function(state, check, node, tree) {


                            /*  if (check.name == "computer"){
                                 if (!state) { // Controlla che il valore esista
                                     const index = self.policy.jobs.computers.indexOf(check.value);
                                     self.policy.jobs.computers.splice(index, 1);
                                 } else {
                                     self.policy.jobs.computers.push(check.value);
                                 }
                             }
                             if (check.name == "backup"){
         
                                 if (!state) { // Controlla che il valore esista
                                     const index = self.policy.jobs.jobs.indexOf(check.value);
                                     self.policy.jobs.jobs.splice(index, 1);
                                 } else {
                                     self.policy.jobs.jobs.push(check.value);
                                 }
                             } */


                        }
                        treeview.collapseAll();
                    }

                    break;
                case 2: //patch sistema operativo
                    var patchview=Metro.getPlugin('#patchview', 'treeview');
                    if (patchview!=undefined) {

                        patchview.options.onCheckClick=function(state, check, node, tree) {
                            if (typeof check.value==='string'&&check.value.startsWith('[')&&check.value.endsWith(']')) {

                                var arraytoPush=JSON.parse(check.value);

                                if (state) {
                                    arraytoPush.forEach(value => self.policy.policy.included_categories.push(value));
                                } else {
                                    arraytoPush.forEach((value) => {
                                        const index=self.policy.policy.included_categories.indexOf(value);
                                        if (index!==-1) { // Controlla che il valore esista
                                            self.policy.policy.included_categories.splice(index, 1);
                                        }
                                    });
                                }



                            } else {
                                const index=self.policy.policy.included_categories.indexOf(check.value);
                                if (index!==-1) { // Controlla che il valore esista
                                    self.policy.policy.included_categories.splice(index, 1);
                                } else {
                                    self.policy.policy.included_categories.push(check.value);
                                }


                            }

                        }
                    }
                    break;
                case 3: //hardware monitoring
                    var threshold_cpu=Metro.getPlugin('#threshold_cpu', 'slider');
                    if (threshold_cpu!=undefined) {
                        threshold_cpu.options.onChangeValue=function(val, percent, slider) {
                            self.policy.policy.threshold_cpu=parseInt(val);
                        }
                        var threshold_ram=Metro.getPlugin('#threshold_ram', 'slider');
                        threshold_ram.options.onChangeValue=function(val, percent, slider) {
                            self.policy.policy.threshold_ram=parseInt(val);
                        }
                        var threshold_disk=Metro.getPlugin('#threshold_disk', 'slider');
                        threshold_disk.options.onChangeValue=function(val, percent, slider) {
                            self.policy.policy.threshold_disk=parseInt(val);
                        }
                    }
            }
        },

        clearSubPolicy() {
            const allowedPropsByType={
                1: ["misfire_alert", "scheduling"], // Scheduling
                2: ["included_categories", "update_time", "reboot_auto", "reboot_time_inf", "reboot_time_sup"], // OS patch
                3: ["threshold_duration", "threshold_cpu", "threshold_disk", "threshold_ram"], // Hardware monitoring
                7: []
            };

            const idType=this.policy.id_type;
            const allowedProps=allowedPropsByType[idType]||[];

            Object.keys(this.policy.policy).forEach(prop => {
                if (allowedProps.length==0||!allowedProps.includes(prop)) {
                    delete this.policy.policy[prop];
                }
            });
        },

        async save() {
            let self=this;
            if (self.policy.name==null||self.policy.name==""||self.policy.id_type=="") {
                Metro.dialog.create({
                    title: this.$t("Error on saving policy"),
                    content: this.$t("*Policy name,type are required"),
                    closeButton: false,
                    clsDialog: "dialog draggable-item error pos-center ",
                    clsContent: "p-10",
                    closeAction: true,
                    actions: [
                        {
                            caption: this.$t("Close"),
                            cls: "js-dialog-close alert "
                        }
                    ],

                });
                return;
            }
            self.policy.groups=[];
            self.policy.computers=[];

            if (self.selectType) {
                self.policy.jobs=[];
                self.policy.groups.update(self.specifiedGroups);
                /* if (self.policy.id_type==1) {
                    self.policy.groups=window.Metro.getPlugin($("#groupselect1"), 'select').val();
                } else {
                    self.policy.groups=window.Metro.getPlugin($("#groupselect"), 'select').val();
                } */
            } else if (window.Metro.getPlugin($("#computerselect"), 'select')) {
                self.policy.computers=window.Metro.getPlugin($("#computerselect"), 'select').val();
            } else {
                self.policy.computers=[];
            }


            var newPolicy=self.policy.id==null? await self.$api.createPolicy(self.policy):await self.$api.editPolicy(self.policy);

            if (newPolicy==null) {
                return;
            }
            
            this.$session.setPolicies(await this.$api.getPolicies());

            this.$root.$emit("refreshPolicies");
            this.clearSubPolicy();
            // devo unire i vecchi computer della policy con gli eventuali nuovi.
            // ovvero una union tra due array self.oldComputers e self.policy.computers
            const merged=Array.from(new Set([...(self.policy.computers||[]), ...self.oldComputers]));

            await self.$api.refreshPoliciesWithArray(merged);

            this.$root.$emit('CLOSEPOLICYVIEWDIALOG');

        },

        onSliderChange(e) {
            const el=e.target

            // prova 1: value dell'input
            let v=Number(el.value)

            // fallback: valore dal plugin Metro
            if (Number.isNaN(v)&&window.Metro?.getPlugin) {
                const slider=window.Metro.getPlugin(el, "slider")
                if (slider?.val) v=Number(slider.val())
            }

            this.policy.policy[el.id]=v;


        },
        ensureIncludedCategories() {
            if (!this.policy||!this.policy.policy) return;

            if (!Array.isArray(this.policy.policy.included_categories)) {
                this.$set(this.policy.policy, "included_categories", []);
            }
        },

        parseValueToIds(rawValue) {
            if (typeof rawValue!=="string") return [];
            const v=rawValue.trim();

            if (v.startsWith("[")) {
                try {
                    const arr=JSON.parse(v);
                    return Array.isArray(arr)? arr:[];
                } catch (e) {
                    return [];
                }
            }
            return [v];
        },

        onCategoryChange(e) {
            this.ensureIncludedCategories();

            const checked=e.target.checked;
            const ids=this.parseValueToIds(e.target.value);

            const current=this.policy.policy.included_categories.slice();
            const set=new Set(current);

            if (checked) ids.forEach(id => set.add(id));
            else ids.forEach(id => set.delete(id));

            this.policy.policy.included_categories=Array.from(set);
        },

        isGroupChecked(ids) {
            const list=(this.policy&&this.policy.policy&&this.policy.policy.included_categories)||[];
            return ids.every(id => list.includes(id));
        }


    }
}
</script>
